var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 18 18",
    id: "telegram_d723--inline",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 3.295l-2.73 11.837c-.107.421-.294.694-.562.818-.24.1-.549.05-.923-.148l-4.136-2.83L7.59 14.76c-.134.124-.24.211-.321.26a1.068 1.068 0 01-.522.113l.321-3.909 7.67-6.44c.106-.074.133-.136.08-.185-.027-.075-.107-.1-.241-.075a.76.76 0 00-.362.112L4.74 10.18.645 8.99c-.455-.124-.67-.31-.643-.559.027-.248.308-.471.843-.67l15.941-5.695c.402-.124.723-.074.964.15.24.198.308.558.2 1.079z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tg.6831dbe7.svg";
export { ForwardRef as ReactComponent };